import { Link } from 'react-router-dom';

export default function CMSTab({ list = [], activeTab, setActiveTab }) {
  return (
    <div className="head-link-set">
      <ul>
        {list.map((item, index) => (
          <li key={index}>
            <Link
              to="#"
              className={activeTab === item.value ? 'active' : ''}
              onClick={() => setActiveTab(item?.value)}
            >
              {item?.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
